import { distributionCardSchema } from "../../../../../schemas/distributionCardSchema";
import { z } from "zod";
import { NodeOutputData, NodeType } from "common/src/modules/nodes/nodes.types";
import { DTDistributionNode } from "common/src/modules/decisionTree/decisionTree.types";

export const convertDistributionAPICardToAICard = (distributionCard: DTDistributionNode): z.input<typeof distributionCardSchema> => {
  const candidate: z.input<typeof distributionCardSchema> = {
    ...distributionCard,
    cardId: distributionCard.id,
    type: NodeType.DISTRIBUTION,
    outputs: distributionCard.outputs.map((output: NodeOutputData) => ({
      nodeId: output.nodeId ?? 0,
      id: output.id,
      name: output.name ?? '',
    })),
  } as z.infer<typeof distributionCardSchema>;

  return candidate;
}